export default __webpack_public_path__ + "static/media/14t.ab0ecfa9.jpg";